export default "__VITE_PUBLIC_ASSET__294747c4__"